module.exports = __webpack_public_path__ + "img/FRO.33ca1c27.svg";